import { defineComponent, h } from "vue";
import { useHead } from "#imports";
import {
  spritePaths,
  runtimeOptions,
  isServer
} from "#nuxt-svg-icon-sprite/runtime";
import { getSymbolNameParts } from "../../helpers/index.js";
export default defineComponent({
  props: {
    name: {
      type: String,
      required: true
    },
    noWrapper: Boolean
  },
  setup(props) {
    if (isServer) {
      const { sprite } = getSymbolNameParts(props.name);
      const href = spritePaths[sprite];
      if (href) {
        useHead({
          link: [
            {
              rel: "prefetch",
              href,
              as: "image",
              type: "image/svg+xml",
              key: href
            }
          ]
        });
      }
    }
    return () => {
      const { symbol, sprite } = getSymbolNameParts(props.name);
      const symbolDom = h("use", {
        href: spritePaths[sprite] + "#" + symbol
      });
      return props.noWrapper ? symbolDom : h(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          "data-symbol": symbol,
          "aria-hidden": runtimeOptions.ariaHidden ? "true" : void 0
        },
        symbolDom
      );
    };
  }
});
if (import.meta.hot) {
  import.meta.hot.accept();
}
